import { Modal, Button } from "react-bootstrap";
import React, { useState, useEffect, useHistory } from "react";
import Collapsible from "react-collapsible";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "../Loader";
const phoneRegExp = /^(^\+251|^251|^0)?9\d{8}$/;

const today = new Date();
today.setHours(0, 0, 0, 0);

const basicSchema = Yup.object().shape({
  usageLimit: Yup.number()
    .required("Usage limit is required")
    .min(0, "Usage limit must be at least 0"),
  
  startDate: Yup.date()
    .nullable()
    .required("Start date is required")
    .min(today, "Start Date cannot be in the past"),

  endDate: Yup.date()
    .nullable()
    .required("End date is required")
    .min(today, "End Date cannot be in the past"),

  status: Yup.string().required("Status is required"),
});

const EditSubscriber = ({ showModal, hideModal, id, data, getSubscribers }) => {
  const history = useNavigate();
  let [loading, setLoading] = useState(false);
  let [errorMsg, setErrorMsg] = useState(true);

  const getDrivers = async () => {
    const response = await axios.get("drivers/").then();
  };

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    editSubscriber(values);
    setLoading(true);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      usageLimit: data.usageLimit,
      startDate: data.startDate,
      endDate: data.endDate,
      status: data.status,
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const customDatePickerStyles = {
    borderRadius: "5px",
    border: "1px solid #ccc",
    padding: "7px",
    fontWeight: 500,
    width: "135%",
    color: "#494848",
  };

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={(val) => {
          onChange(name, val);
        }}
        customInput={<input style={customDatePickerStyles} />}
      />
    );
  };
  const notifySuccess = () =>
    toast.info("Subscriber info Updated.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const editSubscriber = async (e, i) => {
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
        bodyFormData.append("id", id);
      }
      console.log("=========company===edit=====", bodyFormData);
      const response = await axios
        .put("/subscriber/" + id, bodyFormData)
        .then((res) => {
          //   history("/");
          hideModal();
          notifySuccess();
          getSubscribers();
          //getDrivers();
        })
        .catch((err) => {
          setLoading(false);
          setErrorMsg(err.response.data.msg);
          notifyError();
        });
    } catch (error) {
      notifyError();
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
      style={{marginTop: "60px"}}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Subscriber</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading && (
            <div
              style={{
                position: "absolute",
                zIndex: "1000",
                top: 50 + "%",
                left: 50 + "%",
              }}
            >
              <Loader />
            </div>
          )}
          <div class="row">
            <div class="col-md-6">
              <div class="card card-primary">
                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Usage Limit</label>
                    <input
                      type="number"
                      name="usageLimit"
                      value={values.usageLimit}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.usageLimit && touched.usageLimit
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.usageLimit && touched.usageLimit && (
                      <p className="error">{errors.usageLimit}</p>
                    )}
                  </div>

                  <div class="form-group">
                    <label for="startDate">Start Date</label>
                    <br />
                    <DatePickerField
                      name="startDate"
                      id="startDate"
                      class="form-control"
                      value={values.startDate}
                      onChange={setFieldValue}
                      className={
                        errors.startDate && touched.startDate
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.startDate && touched.startDate && (
                      <p className="error">{errors.startDate}</p>
                    )}
                  </div>
                  <div class="form-group">
                    <label for="endDate">End Date</label>
                    <br />
                    <DatePickerField
                      name="endDate"
                      id="endDate"
                      class="form-control"
                      value={values.endDate}
                      onChange={setFieldValue}
                      className={
                        errors.endDate && touched.endDate
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />

                    {errors.endDate && touched.endDate && (
                      <p className="error">{errors.endDate}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <label for="inputStatus">Status</label>
                    <select
                      id="inputStatus"
                      class="form-control custom-select"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.status && touched.status
                          ? "form-control input-error"
                          : "form-control "
                      }
                    >
                      <option selected>Select Status</option>
                      <option value={"Active"}>Active</option>
                      <option value={"Inactive"}>Inactive</option>
                    </select>
                    {errors.status && touched.status && (
                      <p className="error">{errors.status}</p>
                    )}
                  </div>
                </div>
                <Button
                  disabled={isSubmitting}
                  //   onClick={addSubscriber}
                  onClick={submitForm}
                  variant="default"
                  // className="btn btn-success"
                  type="submit"
                  style={{
                    border: "1px solid #8d8585",
                    borderRadius: "7px",
                    margin: "5px 13px",
                  }}
                >
                  Update
                </Button>
                <Button
                  style={{
                    border: "1px solid #8d8585",
                    borderRadius: "7px",
                    margin: "5px 13px",
                    marginTop: "10px",
                  }}
                  variant="default"
                  onClick={hideModal}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </form>
  );
};

export default EditSubscriber;
